import type { AxiosInstance } from 'axios';
import {
  AdminExchangeApi,
  AdminManagementHistoryApi,
  AdminPointApi,
  AdminSnsAccountsApi,
  AdminUsersApi,
  AdminViewingApi,
  MasterStatisticsApi,
} from '../lib';
import {
  AdminAppReviewEventsApi,
  AdminAttendanceTypesApi,
  AdminGifticonsApi,
  AdminLuckyDrawsApi,
  AdminNoticesApi,
  AdminNotificationApi,
  AdminSnsServerApi,
  AdminStoreOrdersApi,
  AdminStoreProductsApi,
  AdminSuggestionsApi,
  CampaignAdminApi,
  PointAdminApi,
  StatisticsAdminApi,
  AdminSnsAccountsApi as V2SnsAccountApi,
  AdminExchangesApi as V2AdminExchangesApi,
  ViewingAdminApi, UserAdminApi
} from '@smiledragon-corp/viewup-backend-api';

export class AdminAPI {
  private _snsServer: AdminSnsServerApi;
  private _snsAccount: V2SnsAccountApi;
  private _viewing: ViewingAdminApi;
  private _campaign: CampaignAdminApi;
  private _point: PointAdminApi;
  private _suggestion: AdminSuggestionsApi;
  private _notices: AdminNoticesApi;
  private _notification: AdminNotificationApi;
  private _refund: V2AdminExchangesApi;
  private _statistics: StatisticsAdminApi;
  private _userAdmin: UserAdminApi;
  /** 응모(추첨) — BE 네이밍은 `lucky draw`다. 어드민 `응모 관리` 화면이 쓴다. */
  private _luckyDraw: AdminLuckyDrawsApi;
  private _gifticon: AdminGifticonsApi;
  /** 포인트 스토어 상품 — 현재 계약은 등록(`POST /v2/admin/store-products`) 하나뿐이다. */
  private _storeProduct: AdminStoreProductsApi;
  /** 포인트 스토어 주문(구매 내역) — 목록 조회(`GET /v2/admin/store/orders`). */
  private _storeOrder: AdminStoreOrdersApi;
  /** 출석(스탬프) 보상 타입 — 조회(`GET`) · 수정(`PATCH /v2/admin/attendance/types/{attendanceTypeUuid}`). */
  private _attendanceType: AdminAttendanceTypesApi;
  /** 앱 리뷰 이벤트 신청 — 목록·상세·반려·보상 지급(`/v2/admin/events/app-review/applications`). */
  private _appReviewEvent: AdminAppReviewEventsApi;

  //v1
  private _v1SnsAccount: AdminSnsAccountsApi;
  private _v1Viewing: AdminViewingApi;
  private _v1Point: AdminPointApi;
  private _v1ManageHistory: AdminManagementHistoryApi;
  private _v1AdminUser: AdminUsersApi;
  private _v1Refund: AdminExchangeApi;
  private _v1Statistics: MasterStatisticsApi;

  constructor(private readonly httpClient: AxiosInstance) {
    this._snsServer = new AdminSnsServerApi(undefined, undefined, httpClient);
    this._snsAccount = new V2SnsAccountApi(undefined, undefined, httpClient);
    this._viewing = new ViewingAdminApi(undefined, undefined, httpClient);
    this._campaign = new CampaignAdminApi(undefined, undefined, httpClient);
    this._point = new PointAdminApi(undefined, undefined, httpClient);
    this._suggestion = new AdminSuggestionsApi(undefined, undefined, httpClient);
    this._notices = new AdminNoticesApi(undefined, undefined, httpClient);
    this._notification = new AdminNotificationApi(undefined, undefined, httpClient);
    this._refund = new V2AdminExchangesApi(undefined, undefined, httpClient);
    this._statistics = new StatisticsAdminApi(undefined, undefined, httpClient);
    this._userAdmin = new UserAdminApi(undefined, undefined, httpClient);
    this._luckyDraw = new AdminLuckyDrawsApi(undefined, undefined, httpClient);
    this._gifticon = new AdminGifticonsApi(undefined, undefined, httpClient);
    this._storeProduct = new AdminStoreProductsApi(undefined, undefined, httpClient);
    this._storeOrder = new AdminStoreOrdersApi(undefined, undefined, httpClient);
    this._attendanceType = new AdminAttendanceTypesApi(undefined, undefined, httpClient);
    this._appReviewEvent = new AdminAppReviewEventsApi(undefined, undefined, httpClient);

    //v1
    this._v1SnsAccount = new AdminSnsAccountsApi(undefined, undefined, httpClient);
    this._v1Viewing = new AdminViewingApi(undefined, undefined, httpClient);
    this._v1Point = new AdminPointApi(undefined, undefined, httpClient);
    this._v1ManageHistory = new AdminManagementHistoryApi(undefined, undefined, httpClient);
    this._v1AdminUser = new AdminUsersApi(undefined, undefined, httpClient);
    this._v1Refund = new AdminExchangeApi(undefined, undefined, httpClient);
    this._v1Statistics = new MasterStatisticsApi(undefined, undefined, httpClient);
  }

  get snsServer() {
    return this._snsServer;
  }

  get snsAccount() {
    return this._snsAccount;
  }

  get viewing() {
    return this._viewing;
  }

  get campaign() {
    return this._campaign;
  }

  get point() {
    return this._point;
  }

  get suggestion() {
    return this._suggestion;
  }

  get notices() {
    return this._notices;
  }

  get notification() {
    return this._notification;
  }

  get refund() {
    return this._refund;
  }
  
  get statistics() {
    return this._statistics;
  }

  get userAdmin() {
    return this._userAdmin;
  }

  get luckyDraw() {
    return this._luckyDraw;
  }

  get gifticon() {
    return this._gifticon;
  }

  get storeProduct() {
    return this._storeProduct;
  }

  get storeOrder() {
    return this._storeOrder;
  }

  get attendanceType() {
    return this._attendanceType;
  }

  get appReviewEvent() {
    return this._appReviewEvent;
  }

  // v1
  get v1SnsAccount() {
    return this._v1SnsAccount;
  }

  get v1Viewing() {
    return this._v1Viewing;
  }

  get v1Point() {
    return this._v1Point;
  }

  get v1ManageHistory() {
    return this._v1ManageHistory;
  }

  get v1AdminUser() {
    return this._v1AdminUser;
  }

  get v1Refund() {
    return this._v1Refund;
  }

  get v1Statistics() {
    return this._v1Statistics;
  }
}
